import React, { useEffect, useState } from 'react';
import { observer } from 'src/utils/mobx-react';

interface ClientSideOnlyPropsType {
    children: React.ReactElement;
    fallback?: React.ReactElement;
}

export const ClientSideOnly = observer('ClientSideOnly', (props: ClientSideOnlyPropsType) => {
    const { children, fallback = null } = props;
    const [hydrated, setHydrated] = useState(false);

    useEffect(() => {
        setHydrated(true);
    }, []);

    if (hydrated === false) {
        return fallback;
    }

    return children;
});
